<template>  
  <div class="sellservicedetail">
    <XR-head titleText="服务订单详情"></XR-head>
    <div class="order-info" v-if="!loaded">
      <div class="filed">
        <div class="title">服务单号：</div>
        <div class="orderno">{{sellServiceInfo.SellServiceNo}}</div>
        <div class="time">{{sellServiceInfo.CreateDateName}}</div>
      </div>
      <div class="detail">
        <div class="process">
          <p class="state">
            <span>{{sellServiceInfo.StateName}}</span>
            <i class="fa fa-check" v-if="sellServiceInfo.State==6"></i>
          </p>
          <p class="refund-money">
            <i class="fa fa-rmb"></i>
            <span>{{sellServiceInfo.ReturnMoney.RealReturnMoney.toFixed(2)}}</span>
          </p>
        </div>
        <div class="refund-info" v-if="sellServiceInfo.State==6">
          <p class="info1">
            <span class="title">退回至金币账户</span>
            <span class="value"><i class="fa fa-rmb"></i>{{sellServiceInfo.ReturnMoney.RealReturnMoney.toFixed(2)}}</span>
          </p>
          <p class="info1" v-if="sellServiceInfo.OrderMoney && sellServiceInfo.OrderMoney.DiscountMoney>0">
            <span class="title">退回至积分账户</span>
            <span class="value">{{sellServiceInfo.OrderMoney && sellServiceInfo.OrderMoney.DiscountMoney}}</span>
          </p>
          <!-- <p class="info1" v-if="sellServiceInfo.WuaPay">
            <span class="title">退回至WUA账户</span>
            <span class="value">{{sellServiceInfo.WuaPay.ZhiLianCoin.toFixed(4)}}</span>
          </p> -->
        </div>
      </div>
    </div>
    <div class="step-div" v-if="!loaded">
      <div class="filed">
        <div class="title">售后进度</div>
      </div>
      <mu-stepper :activeStep="getStep(sellServiceInfo.State)" orientation="vertical" class="step-list">
        <mu-step>
          <mu-step-label>
            提交申请
          </mu-step-label>
          <mu-step-content>
            <p>
              您的申请已提交，请耐心等待审核，谢谢您的配合。
            </p>
          </mu-step-content>
        </mu-step>
        <mu-step v-if="sellServiceInfo.ServiceType==1 && !(sellServiceInfo.State==7||sellServiceInfo.State==8)">
          <mu-step-label>
            买家发货
          </mu-step-label>
          <mu-step-content>
            <p>
              您的售后申请已通过，请将货物发给商家。<mu-raised-button :to="'/usercenter/sellservicedelivery?sellServiceNo='+ sellServiceInfo.SellServiceNo" primary>发货</mu-raised-button>
            </p>
          </mu-step-content>
        </mu-step>
        <mu-step v-if="sellServiceInfo.ServiceType==1 && !(sellServiceInfo.State==7||sellServiceInfo.State==8)">
          <mu-step-label>
            等待卖家收货
          </mu-step-label>
          <mu-step-content>
            <p>
              货物已发出，请等待卖家收货
            </p>
          </mu-step-content>
        </mu-step>
        <mu-step v-if="!(sellServiceInfo.State==7||sellServiceInfo.State==8)">
          <mu-step-label>
            待退款
          </mu-step-label>
          <mu-step-content>
            <p>
              卖家已收货，请等待退款
            </p>
          </mu-step-content>
        </mu-step>
        <mu-step>
          <mu-step-label>            
            {{sellServiceInfo.State == 7 ? '已取消' : sellServiceInfo.State == 8? '已关闭':'交易完成'}}
          </mu-step-label>
          <mu-step-content>
            <p>
              您的售后申请{{sellServiceInfo.State == 7 ? '已取消' : sellServiceInfo.State == 8? '已关闭':'已完成'}}，如有疑问，请拨打客服热线
            </p>
          </mu-step-content>
        </mu-step>
      </mu-stepper>
      
    </div>

    <div class="sellservice-info" v-if="!loaded">
      <div class="filed">
        <div class="title">留言消息</div>
      </div>
      <mu-timeline class="msgList">
        <mu-timeline-item v-for="msg in sellServiceInfo.Messages" :key="msg.MsgId">
          <span slot="time">{{msg.CreateDateName}}</span>
          <span slot="des" class="desc">
            {{msg.OperatorPerson + ":" +msg.Title}}<br>
            {{msg.MsgContent}}
          </span>
        </mu-timeline-item>
      </mu-timeline>
    </div>
    <!-- <div class="apply-info" v-if="!loaded">
      <div class="filed">
        <div class="title">审核留言</div>
      </div>
      <div class="apply-msg">
        {{sellServiceInfo.Apply.}}
      </div>
    </div> -->
    
    <div class="request-info" v-if="!loaded">
      <div class="filed">
        <div class="title">问题描述</div>
      </div>
      <div class="request-msg">
        {{sellServiceInfo.Apply.ApplyContent}}<br>        
        {{sellServiceInfo.Apply.CreateDateName}}
      </div>
    </div>
    
    <div class="sellservice-info" v-if="!loaded">
      <div class="filed">
        <div class="title">服务单信息</div>
      </div>
      <div class="sellservice-info-list">
        <p class="list-item">
          <span class="title">服务类型：</span>
          <span class="value">{{sellServiceInfo.ServiceTypeName}}</span>
        </p>
        <p class="list-item">
          <span class="title">联系人：</span>
          <span class="value">{{sellServiceInfo.Receive.Receiver}}</span>
        </p>
        <p class="list-item">
          <span class="title">联系电话：</span>
          <span class="value">{{sellServiceInfo.Receive.Phone}}</span>
        </p>
      </div>
    </div>
    <mu-float-button icon=":fa fa-services2" :to="'/usercenter/sellservicemsg?sellServiceNo='+sellServiceInfo.SellServiceNo" class="btn-cs-add" primary />
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      activeTab: 'tab1',
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      sellServiceInfo:{},
      loaded:true
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getDetail()
  },
  methods: {
    handleTabChange (val) {
      this.activeTab = val
    },
    getStep(state){
      if(state == 1){
        return 0
      }
      else if(state == 2){
        return 1
      }
      else if(state == 3){
        return 2
      }
      else if(state == 9){
        if(this.sellServiceInfo.ServiceType == 3){
          return 1
        }
        else{
          return 3
        }
      }
      else if(state == 6){
        if(this.sellServiceInfo.ServiceType == 3){
          return 2
        }
        else{
          return 4
        }
      }
      else if(state == 7 ||state == 8){
        return 1
      }
    },
    handleActive () {
    },
    getDetail(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetSellServiceOrder",
        JSON.stringify({SellServiceNo:this.$route.query.sellServiceNo})
      ).then(function(res) {
        if(!res.IsSuccess){     
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.sellServiceInfo =res.Data
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
}
</script>

<style>
#app .sellservicedetail{
  bottom:unset;
  padding-bottom: 20px;
}
.sellservicedetail .filed{
  line-height: 24px;
  font-size: 12px;
  overflow: hidden;
  border-bottom:1px solid #eee;
  padding: 6px 0;
}
.sellservicedetail .step-div .filed{
  margin: 0 10px;
  padding-top: 10px;
}
.sellservicedetail .apply-info .filed{
  margin: 0 10px;
  padding-top: 10px;
}
.sellservicedetail .request-info .filed{
  margin: 0 10px;
  padding-top: 10px;
}
.sellservicedetail .sellservice-info .filed{
  margin: 0 10px;
  padding-top: 10px;
}
.sellservicedetail .sellservice-info .msgList{
  padding: 30px 20px 0;
}
.sellservicedetail .sellservice-info .msgList .desc{
  font-size: 14px;
}


.sellservicedetail .filed .title{
  color:#333;
  float: left;
}
.sellservicedetail .filed .orderno{
  color:#999;
  float: left;
}
.sellservicedetail .filed .time{
  color:#999;
  float: right;
}

.sellservicedetail .order-info{
  overflow: hidden;
  background: white;
  padding: 0 10px 10px;
}

.sellservicedetail .detail {
  overflow: hidden;
}
.sellservicedetail .detail .process {
  padding: 30px 0;
  overflow: hidden;
}
.sellservicedetail .detail .state {
  width: 50%;
  float: left;
  text-align: right;
  padding-right: 10px;
  color:green;
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
}
.sellservicedetail .detail .state .fa{
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  overflow: hidden;
  background: green;
  color:white;
  text-align: center;
  float: right;
}
.sellservicedetail .detail .state span{
  float: right;
  margin-left: 10px;
}
.sellservicedetail .detail .refund-money {
  width: 50%;
  float: right;
  padding-left: 10px;
  font-size: 12px;
}
.sellservicedetail .detail .refund-money .fa{
  float: left;
  line-height: 16px;
}
.sellservicedetail .detail .refund-money span{
  line-height: 16px;
  font-size: 14px;
  float: left;
}

.sellservicedetail .detail .refund-info {
  overflow: hidden;
  padding-bottom: 10px;
}
.sellservicedetail .detail .info1{
  overflow: hidden;
  font-size: 12px;
  line-height: 24px;
  color:#999;
}
.sellservicedetail .detail .info1 .title{
  float: left;
}
.sellservicedetail .detail .info1 .value {
  float: right;
}
.sellservicedetail .step-div {
  background: white;
  margin-top: 10px;
  overflow: hidden;
}
.sellservicedetail .step-list {  
  padding: 20px 0;
}

.sellservicedetail .apply-info {
  background: white;
  margin-top: 10px;
}
.sellservicedetail .apply-msg {
  font-size: 12px;
  color:#999;
  padding:20px 10px;
}
.sellservicedetail .request-info {
  background: white;
  margin-top: 10px;
}
.sellservicedetail .request-msg {
  font-size: 12px;
  color:#999;
  padding:20px 10px;
}
.sellservicedetail .sellservice-info {
  background: white;
  margin-top: 10px;
  padding-bottom: 20px;
}
.sellservicedetail .list-item {
  overflow: hidden;
  padding: 10px 10px 0;
  line-height: 14px;
}
.sellservicedetail .list-item .title {
  width: 70px;
  float: left;
  color:#999;
  font-size: 12px;
}
.sellservicedetail .list-item .value {
  float: left;
  font-size: 12px;
}


.sellservicedetail .btn-cs-add{
  position: fixed;
  bottom: 60px;
  right: 20px;
}
.sellservicedetail .msgList .mu-timeline-item-content{
  width: calc(100% - 30px)
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sellservicedetail.vue